import IPCService from './inPageConditioningService';

const IPCServiceInstance = new IPCService();

export default IPCServiceInstance;
